import getUniqueId from 'helpers/getUniqueId'

import type { Widget } from 'js/page/PageEditor/PageEditor.types'

export function cloneWidget(widget: Widget): Widget {
    const {
        guid: _guid,
        userSettings: _userSettings,
        widgetGuid: _widgetGuid,
        ...rest
    } = widget
    return {
        ...structuredClone(rest),
        widgetGuid: getUniqueId('widget'),
    }
}
